<template>
  <div class="form-container">
    <a-form layout="inline">
      <slot></slot>

      <a-form-item>

        <a-button class="search-btn" v-if="showExport" type="primary" @click="onExportExcel">
          导出Excel
        </a-button>

        <a-button class="search-btn" type="primary" @click="onSubmit" :loading="loading">
          查询
        </a-button>
        <a-button class="search-btn" @click="onReset" v-if="showReset">
          重置
        </a-button>
      </a-form-item>
    </a-form>
  </div>
</template>

<script>
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'SearchForm',
  components: {
  },
  props: {
    showExport: {
      type: Boolean,
      default: false
    },
    showReset: {
      type: Boolean,
      default: true
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  emit: ['submit', 'reset'],
  setup (props, { emit }) {
    const onSubmit = () => {
      emit('submit')
    }
    const onReset = () => {
      emit('reset')
    }

    const onExportExcel = () => {
      emit('exportExcel')
    }

    return {
      onSubmit,
      onReset,
      onExportExcel
    }
  }
})
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
@import '@/style/variables.less';

// 筛选区给一块浅色底，把"筛选条件"和下面的"结果表格"分成两段。
// 原来筛选项直接浮在白底上，和表格连成一片，看不出边界。
.form-container {
  background: @bg-hover;
  border: 1px solid @border-2;
  border-radius: @radius-md;
  padding: 14px 16px 6px;
  margin-bottom: 16px;

  :deep(.ant-form-item) {
    margin-right: 16px;
    margin-bottom: 8px;
  }
  :deep(.ant-form-item-label > label) {
    color: @text-3;
    font-weight: 400;
    font-size: 13px;
  }
  :deep(.ant-input),
  :deep(.ant-select-selector),
  :deep(.ant-picker) {
    background: @bg-surface;
  }

  .search-btn { margin-left: 8px; }
}
</style>
